export const MAX_NUMBER_OF_MARKETING_LINKS = 5
